import {
  CustomerInfo,
  LOG_LEVEL,
  MakePurchaseResult,
  Purchases,
  PURCHASES_ERROR_CODE,
  PurchasesPackage,
} from '@revenuecat/purchases-capacitor';
import configuration from '../services/configuration';
import { capacitorService } from './CapacitorService';

class RevenueCatService {
  private _isLogged = false;

  isLogged(): boolean {
    return this._isLogged;
  }

  async logIn({ appUserID }: { appUserID: string }): Promise<void> {
    let apiKey;
    if (capacitorService.isWeb()) {
      await Purchases.setMockWebResults({ shouldMockWebResults: true });
      apiKey = `goog_qbKUZzsewZLKlCycetWFOnaJuWi`;

      // TODO: WHEN WEB APPLICATION IS SET IN REVENUECAT
      // Eliminar setMockWebResults
      // apiKey = `web_api_key`,
    } else if (capacitorService.isAndroid()) {
      apiKey = `goog_qbKUZzsewZLKlCycetWFOnaJuWi`;
    } else if (capacitorService.isIOS()) {
      apiKey = `appl_ZFxXxRBBnGVIvSEnpgktGdVaKdD`;
    } else {
      throw new Error(`PLATFORM_NOT_SUPPORTED`);
    }

    await Purchases.configure({
      apiKey,
      appUserID,
    });

    if (configuration.ENVIRONMENT === `DEVELOPMENT`) {
      await Purchases.setLogLevel({ level: LOG_LEVEL.DEBUG }); // Enable to get debug logs
    }

    this._isLogged = true;
  }

  async logOut(): Promise<void> {
    if (this.isLogged()) {
      await Purchases.logOut();
      this._isLogged = false;
    }
  }

  async getCustomerInfo(): Promise<CustomerInfo> {
    if (!this.isLogged()) {
      throw new Error(`NOT_LOGGED_IN`);
    }

    const { customerInfo } = await Purchases.getCustomerInfo();
    return customerInfo;
  }

  async setPhoneNumber(phoneNumber: string): Promise<void> {
    if (!this.isLogged()) {
      throw new Error(`NOT_LOGGED_IN`);
    }
    return Purchases.setPhoneNumber({ phoneNumber });
  }

  async setAttributes(attributes: Record<string, string>): Promise<void> {
    // Example of revenuecat attributes. https://docs.revenuecat.com/docs/subscriber-attributes
    // Purchases.setPhoneNumber(`+1234567890`);
    // Purchases.setEmail(`asd@wwdsd.com`);

    return Purchases.setAttributes(attributes);
  }

  async getSubscriptionPackages(): Promise<PurchasesPackage[]> {
    if (!this.isLogged()) {
      throw new Error(`NOT_LOGGED_IN`);
    }
    const offerings = await Purchases.getOfferings();
    if (offerings.current !== null && offerings.current.availablePackages.length !== 0) {
      return offerings.current.availablePackages;
    }
    return [];
  }

  // async purchasePackage(packageId: PurchasesPackage): Promise<MakePurchaseResult> {
  //   return Purchases.purchasePackage({ aPackage: packageId });
  // }

  async purchasePackage(packageId: PurchasesPackage): Promise<MakePurchaseResult> {
    if (!this.isLogged()) {
      throw new Error(`NOT_LOGGED_IN`);
    }

    try {
      return Purchases.purchasePackage({ aPackage: packageId });

      // if (typeof purchaseResult.customerInfo.entitlements.active[`my_entitlement_identifier`] !== `undefined`) {
      //   // Unlock that great "pro" content
      // }
    } catch (error: any) {
      if (error.code === PURCHASES_ERROR_CODE.PURCHASE_CANCELLED_ERROR) {
        // Purchase cancelled
        throw new Error(`PURCHASE_CANCELLED`, error);
      } else {
        // Error making purchase
        throw new Error(`PURCHASE_UNKNOWN_ERROR`, error);
      }
    }
  }
}

export const revenueCatService = new RevenueCatService();
